import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import ui from '../services/ui';

class WeekdaysDropdown extends Component {
	render() {
		const { id = 'weekdaysDropdown', selectedWeekday, t } = this.props;


		return <DropdownButton id={id} onSelect={key => this.props.onSelectWeekday(Number(key))}
			className='btn-block-xxs'
			bsStyle={selectedWeekday ? 'primary' : 'default'}
			title={selectedWeekday ? t(ui.days[selectedWeekday]) : t('FO_TimetableSearch_AnyDay')}
		>
			<MenuItem key='anyday' eventKey={null} >{t('FO_TimetableSearch_AnyDay')}</MenuItem>
			{Object.keys(ui.days).filter(key => Number(key) > 0).map(key => <MenuItem key={key} eventKey={key} >{t(ui.days[key])}</MenuItem>)}
		</DropdownButton>;
	}
}

WeekdaysDropdown.propTypes = {
	selectedWeekday: PropTypes.number,
	onSelectWeekday: PropTypes.func.isRequired
};

export default withTranslation()(WeekdaysDropdown);